import styles from './spinner.module.scss'

type SpinnerProps = {
  color?: string
  /**
   * CSS scale value
   *
   */
  scale?: string
  className?: string
}

export default function Spinner({ color = '#D546F8', scale = '1', className = '' }: SpinnerProps): JSX.Element {
  return (
    <svg
      className={`${styles['loading-spinner']} ${className}`}
      style={{ scale }}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle className={styles['loading-circle']} cx="20" cy="20" r="18" stroke={color} strokeWidth="4" />
    </svg>
  )
}
